import { orderSharesQty } from "./orderLots";
const startOfUtcDay = (date) => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
const fillPrice = (order) => typeof order.realized_price === "number" ? order.realized_price : order.price;
const tradeFees = (order) => (order.fee ?? 0) + (order.tax ?? 0);
export const computeRealizedTradingPnl = (orders, dayStart) => {
    const filled = orders
        .filter((order) => order.status === "filled" && order.is_shadow !== true)
        .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    const runningQty = new Map();
    const runningAvg = new Map();
    let realizedTotal = 0;
    let realizedToday = 0;
    for (const order of filled) {
        const ticker = order.ticker.toUpperCase();
        const ratio = typeof order.partial_fill_ratio === "number" ? order.partial_fill_ratio : 1;
        const shares = orderSharesQty(order) * ratio;
        if (shares <= 0)
            continue;
        const price = fillPrice(order);
        const fees = tradeFees(order);
        if (order.side === "BUY") {
            const oldQty = runningQty.get(ticker) ?? 0;
            const newQty = oldQty + shares;
            if (newQty > 0) {
                const cost = oldQty * (runningAvg.get(ticker) ?? 0) + shares * price + fees;
                runningAvg.set(ticker, cost / newQty);
            }
            runningQty.set(ticker, newQty);
            continue;
        }
        if (order.side !== "SELL")
            continue;
        const qtyHeld = runningQty.get(ticker) ?? 0;
        const avg = qtyHeld > 0 ? (runningAvg.get(ticker) ?? price) : price;
        const tradeRealized = Math.round((price - avg) * shares - fees * 100) / 100;
        realizedTotal += tradeRealized;
        if (dayStart && new Date(order.created_at) >= dayStart) {
            realizedToday += tradeRealized;
        }
        const nextQty = Math.max(0, qtyHeld - shares);
        runningQty.set(ticker, nextQty);
        if (nextQty < 1e-9) {
            runningQty.set(ticker, 0);
            runningAvg.set(ticker, 0);
        }
    }
    return {
        realizedTotal: Math.round(realizedTotal * 100) / 100,
        realizedToday: Math.round(realizedToday * 100) / 100,
    };
};
export const buildTradingPnlBreakdown = (orders, unrealizedPnl, now = new Date()) => {
    const { realizedTotal, realizedToday } = computeRealizedTradingPnl(orders, startOfUtcDay(now));
    const unrealized = Math.round(unrealizedPnl * 100) / 100;
    const realized_pnl_total = realizedTotal;
    const realized_pnl_today = realizedToday;
    return {
        realized_pnl_total,
        realized_pnl_today,
        unrealized_pnl: unrealized,
        trading_pnl_total: Math.round((realized_pnl_total + unrealized) * 100) / 100,
        trading_pnl_today: realized_pnl_today,
    };
};
